import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-it-helpdesk-modal",
  imports: [],
  templateUrl: "./it-helpdesk-modal.component.html",
  styleUrls: ["./it-helpdesk-modal.component.scss"],
})
export class ItHelpdeskModalComponent implements OnInit {
  protected helpdeskTitle = "";
  protected helpdeskContactPrefix = "";
  protected helpdeskContactJoiner = "";

  constructor(
    private readonly matDialog: MatDialog,
    private readonly translate: TranslateService,
  ) {}

  ngOnInit() {
    this.helpdeskTitle = this.translate.instant("LOGIN.FORM.IT_HELPDESK");
    this.helpdeskContactPrefix = this.translate.instant(
      "LOGIN.FORM.HELPDESK_CONTACT_PREFIX",
    );
    this.helpdeskContactJoiner = this.translate.instant(
      "LOGIN.FORM.HELPDESK_CONTACT_JOINER",
    );
  }

  protected close() {
    this.matDialog.closeAll();
  }
}
